export const SHIP_TO_STORE_SORTATION_CENTERS = ["SC_DFW_1", "SC_TST_1"];
